import React from 'react';

const iconProps = {
    width: 22,
    height: 22,
    viewBox: '0 0 24 24',
    fill: 'none',
    xmlns: 'http://www.w3.org/2000/svg'
};

export const PlayersLauncherIcon = () => (
    // eslint-disable-next-line tpe/no-props-spread -- TODO: legacy props spread (baseline)
    <svg {...iconProps}>
        <path
            d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"
            fill="currentColor"
        />
    </svg>
);

export const TeamsLauncherIcon = () => (
    // eslint-disable-next-line tpe/no-props-spread -- TODO: legacy props spread (baseline)
    <svg {...iconProps}>
        <path
            d="M16 11c1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3 1.34 3 3 3zM8 11c1.66 0 3-1.34 3-3S9.66 5 8 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5C15 14.17 10.33 13 8 13zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z"
            fill="currentColor"
        />
    </svg>
);

export const EventsLauncherIcon = () => (
    // eslint-disable-next-line tpe/no-props-spread -- TODO: legacy props spread (baseline)
    <svg {...iconProps}>
        <path
            d="M19 4h-1V2h-2v2H8V2H6v2H5c-1.11 0-1.99.9-1.99 2L3 20c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 16H5V10h14v10zm0-12H5V6h14v2z"
            fill="currentColor"
        />
    </svg>
);

export const ExploreLauncherIcon = () => (
    <svg width={22} height={22} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M12 10.9c-.61 0-1.1.49-1.1 1.1s.49 1.1 1.1 1.1c.61 0 1.1-.49 1.1-1.1s-.49-1.1-1.1-1.1zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm2.19 12.19L6 18l3.81-8.19L18 6l-3.81 8.19z"
            fill="currentColor"
        />
    </svg>
);

export const PlayerComparisonLauncherIcon = () => (
    // eslint-disable-next-line tpe/no-props-spread -- TODO: legacy props spread (baseline)
    <svg {...iconProps}>
        <path
            d="M8 4c1.66 0 3 1.34 3 3S9.66 10 8 10 5 8.66 5 7s1.34-3 3-3zm8 0c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zM8 12c2.21 0 6.5 1.11 6.5 3.33V19H1.5v-3.67C1.5 13.11 5.79 12 8 12zm8 0c.34 0 .68.02 1 .06 1.93.35 5.5 1.5 5.5 3.27V19h-6.5v-3.67c0-.74-.2-1.38-.55-1.92.5-.1 1.02-.16 1.55-.16z"
            fill="currentColor"
        />
    </svg>
);

export const PlaylistsLauncherIcon = () => (
    // eslint-disable-next-line tpe/no-props-spread -- TODO: legacy props spread (baseline)
    <svg {...iconProps}>
        <path d="M4 6h16v2H4V6zm0 5h16v2H4v-2zm0 5h10v2H4v-2z" fill="currentColor" />
    </svg>
);

export const RawVideoLauncherIcon = () => (
    // eslint-disable-next-line tpe/no-props-spread -- TODO: legacy props spread (baseline)
    <svg {...iconProps}>
        <path d="M8 5v14l11-7L8 5zm12 14H4V5h16v14zm2-16H2v18h20V3z" fill="currentColor" />
    </svg>
);

export const ScheduleLauncherIcon = () => (
    // eslint-disable-next-line tpe/no-props-spread -- TODO: legacy props spread (baseline)
    <svg {...iconProps}>
        <path
            d="M19 3h-1V1h-2v2H8V1H6v2H5c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 18H5V8h14v13z"
            fill="currentColor"
        />
    </svg>
);

export const ConnectLauncherIcon = () => (
    // eslint-disable-next-line tpe/no-props-spread -- TODO: legacy props spread (baseline)
    <svg {...iconProps}>
        <path
            d="M3.9 12c0-1.71 1.39-3.1 3.1-3.1h4V7H7c-2.76 0-5 2.24-5 5s2.24 5 5 5h4v-1.9H7c-1.71 0-3.1-1.39-3.1-3.1zM8 13h8v-2H8v2zm9-6h-4v1.9h4c1.71 0 3.1 1.39 3.1 3.1s-1.39 3.1-3.1 3.1h-4V17h4c2.76 0 5-2.24 5-5s-2.24-5-5-5z"
            fill="currentColor"
        />
    </svg>
);

export const GlossaryLauncherIcon = () => (
    // eslint-disable-next-line tpe/no-props-spread -- TODO: legacy props spread (baseline)
    <svg {...iconProps}>
        <path
            d="M18 2H6c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM6 4h5v8l-2.5-1.5L6 12V4z"
            fill="currentColor"
        />
    </svg>
);

export const SupportLauncherIcon = () => (
    // eslint-disable-next-line tpe/no-props-spread -- TODO: legacy props spread (baseline)
    <svg {...iconProps}>
        <path
            d="M12 1c-4.97 0-9 4.03-9 9v7c0 1.66 1.34 3 3 3h3v-8H5v-2c0-3.87 3.13-7 7-7s7 3.13 7 7v2h-4v8h3c1.66 0 3-1.34 3-3v-7c0-4.97-4.03-9-9-9z"
            fill="currentColor"
        />
    </svg>
);

export const HomeLauncherIcon = () => (
    // eslint-disable-next-line tpe/no-props-spread -- TODO: legacy props spread (baseline)
    <svg {...iconProps}>
        <path d="M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z" fill="currentColor" />
    </svg>
);

export const ShiftsLauncherIcon = () => (
    // eslint-disable-next-line tpe/no-props-spread -- TODO: legacy props spread (baseline)
    <svg {...iconProps} viewBox="0 0 16 16">
        <path d="M6 16H10V0H6V16ZM0 16H4V8H0V16ZM12 5V16H16V5H12Z" fill="currentColor" />
    </svg>
);

export const GoaltendersLauncherIcon = () => (
    // eslint-disable-next-line tpe/no-props-spread -- TODO: legacy props spread (baseline)
    <svg {...iconProps}>
        <path
            d="M12 2C8.13 2 5 5.13 5 9v3c0 1.1.9 2 2 2h1v6h8v-6h1c1.1 0 2-.9 2-2V9c0-3.87-3.13-7-7-7zm-2 9c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm4 0c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z"
            fill="currentColor"
        />
    </svg>
);

export const PlayersPageLauncherIcon = () => (
    // eslint-disable-next-line tpe/no-props-spread -- TODO: legacy props spread (baseline)
    <svg {...iconProps} viewBox="0 0 16 16">
        <path
            d="M0.0010376 8.88889H7.11211V0H0.0010376V8.88889ZM0.0010376 16H7.11211V10.6667H0.0010376V16ZM8.88988 16H16.001V7.11111H8.88988V16ZM8.88988 0V5.33333H16.001V0H8.88988Z"
            fill="currentColor"
        />
    </svg>
);

export const GearLauncherIcon = () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M19.14 12.94c.04-.31.06-.63.06-.94s-.02-.63-.06-.94l2.03-1.58a.5.5 0 00.12-.64l-1.92-3.32a.5.5 0 00-.6-.22l-2.39.96a7.03 7.03 0 00-1.63-.94l-.36-2.54A.5.5 0 0014.9 2h-3.8a.5.5 0 00-.49.42l-.36 2.54c-.59.24-1.13.55-1.63.94l-2.39-.96a.5.5 0 00-.6.22L3.71 8.84a.5.5 0 00.12.64l2.03 1.58c-.04.31-.06.63-.06.94s.02.63.06.94L3.83 14.52a.5.5 0 00-.12.64l1.92 3.32c.13.23.4.32.64.22l2.39-.96c.5.39 1.04.7 1.63.94l.36 2.54c.05.24.25.42.49.42h3.8c.24 0 .44-.18.49-.42l.36-2.54c.59-.24 1.13-.55 1.63-.94l2.39.96c.24.1.51.01.64-.22l1.92-3.32a.5.5 0 00-.12-.64l-2.03-1.58zM12 15.5A3.5 3.5 0 1112 8.5a3.5 3.5 0 010 7z"
            fill="currentColor"
        />
    </svg>
);

export const LAUNCHER_ICONS = {
    home: HomeLauncherIcon,
    shifts: ShiftsLauncherIcon,
    goaltenders: GoaltendersLauncherIcon,
    playersPage: PlayersPageLauncherIcon,
    players: PlayersLauncherIcon,
    teams: TeamsLauncherIcon,
    events: EventsLauncherIcon,
    explore: ExploreLauncherIcon,
    playerComparison: PlayerComparisonLauncherIcon,
    teamComparison: TeamsLauncherIcon,
    playlists: PlaylistsLauncherIcon,
    raw: RawVideoLauncherIcon,
    schedule: ScheduleLauncherIcon,
    connect: ConnectLauncherIcon,
    glossary: GlossaryLauncherIcon,
    support: SupportLauncherIcon
};
